import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { Modal } from '@vibrent/electryon';
import styles from './styles.scss';

const { InformationModal } = Modal;

const DeleteModal = (props) => {
  const {
    show,
    setIsShowConfirmModal,
    key,
    handleSubmit,
  } = props;

  const onClose = () => setIsShowConfirmModal(false);
  const titleModal = 'Delete Survey';

  const confirmModal = {
    title: titleModal,
    body: (<div className="body-content">
      <div className="content-note">
        Are you sure you want to delete this survey?
      </div>
    </div>),
    btnOne: {
      text: 'Cancel',
      bsStyle: 'default',
      className: 'btn-donot',
      onClick: onClose,
    },
    btnTwo: {
      text: 'Delete',
      bsStyle: 'danger',
      className: 'btn-continue',
      onClick: () => handleSubmit(),
    },
  };

  const renderFooter = () => (
    <div>
      <Button
        aria-label={confirmModal.btnOne.text}
        className={`btn-md ${confirmModal.btnOne.className
          ? confirmModal.btnOne.className : ''}`.trim()}
        bsStyle={confirmModal.btnOne.bsStyle}
        onClick={confirmModal.btnOne.onClick}
        disabled={confirmModal.btnOne.disabled}
      >
        {confirmModal.btnOne.text}
      </Button>
      <Button
        aria-label={confirmModal.btnTwo.text}
        className={`btn-md ${confirmModal.btnTwo.className
          ? confirmModal.btnTwo.className : ''}`.trim()}
        bsStyle={confirmModal.btnTwo.bsStyle}
        onClick={confirmModal.btnTwo.onClick}
        disabled={confirmModal.btnTwo.disabled}
      >
        {confirmModal.btnTwo.text}
      </Button>
    </div>
  );

  return (show && <InformationModal
    id={key}
    className={styles['info-modal-template']}
    aria-modal="true"
    backdrop="static"
    show={show}
    title={confirmModal.title}
    body={confirmModal.body}
    footer={renderFooter()}
    onHide={onClose}
  />);
};

DeleteModal.propTypes = {
  show: PropTypes.bool,
  key: PropTypes.string,
  setIsShowConfirmModal: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

DeleteModal.defaultProps = {
  show: false,
  key: 'confirm-modal',
};

export default DeleteModal;
